// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"3681efdf","118":"336f0e4f","132":"2af5c1d5","311":"430068ca","453":"80a3832a","513":"f4e13781"}[chunkId] + ".chunk.js";
};